import SEO from "@/components/SEO";
import BlogList from "@/components/BlogList";
import { motion } from "framer-motion";

export default function Blog() {
  return (
    <>
      <SEO
        title="Blog - ZeeX Soft | Tech Insights & Industry News"
        description="Stay updated with the latest technology trends, software development insights, and industry news from ZeeX Soft's expert team."
        keywords="tech blog, software development blog UAE, web development insights, mobile app trends"
      />

      {/* Hero Section */}
      <section className="pt-32 pb-20 relative overflow-hidden">
        <div className="absolute inset-0 tech-grid opacity-30"></div>
        <div className="container mx-auto px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h1 className="font-orbitron font-bold text-5xl md:text-6xl gradient-text mb-6">
              Tech Insights & News
            </h1>
            <p className="text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto">
              Stay ahead of the curve with our latest thoughts on technology, innovation, and digital transformation
            </p>
          </motion.div>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <BlogList />
        </div>
      </section>
    </>
  );
}
